import bugsnag from 'bugsnag-js'

import React from 'react'
import * as ReactDOM from 'react-dom'
import thunk from 'redux-thunk'

import App from './containers/App'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, Middleware, compose } from 'redux'
import reducer from './reducers'
import { RootState } from './types'

import { syncTranslationWithStore, loadTranslations, setLocale } from 'react-redux-i18n'
import { epicMiddleware } from './epics'
import { translations } from './utils/translations'
import { init } from './utils/init'

import './styles/sass/main.scss'

const createPlugin = require('bugsnag-react')
const apiPrefix = process.env.REACT_APP_DEFAULT_API_URL_PREFIX || ''
const apiPort = process.env.REACT_APP_DEFAULT_API_PORT

export const config = {
  mt4Platform: 'web',
  mt4Version: 4,
  defaultSymbol: process.env.REACT_APP_DEFAULT_SYMBOL,
  defaultWebApiUrl: `${apiPrefix}${window.location.hostname
    .split('.')
    .slice(1)
    .join('.')}${apiPort ? ':' + apiPort : ''}`,
  allowedPostMessageOrigins: (process.env.REACT_APP_ALLOWED_POST_MESSAGE_ORIGINS || '').split(','),
  signalsUrl: process.env.REACT_APP_SIGNALS_API_URL,
  signalsToken: process.env.REACT_APP_SIGNALS_API_TOKEN,
}
const middlewares: Middleware[] = [epicMiddleware, thunk]

const composeEnhancers =
  /showMustGoOn=/.test(document.cookie) &&
  typeof window === 'object' &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares)
  // other store enhancers if any
)

export const store: any = createStore<RootState>(reducer, enhancer)

syncTranslationWithStore(store)
store.dispatch(loadTranslations(translations) as any)
store.dispatch(setLocale('en') as any)

init(config, store)

const bugsnagClient = bugsnag('nothing')
const ErrorBoundary = bugsnagClient.use(createPlugin(React))

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      {/*<SignalsTableFC/>*/}
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('webtrader') as HTMLElement
)
